import type { TemplateBuilderState } from './builder-context';
import type { MarketingTemplatePreset } from 'src/app/queries/marketing/campaign-templates/get-campaign-templates';

export const getCampaignTemplatesPayload = (
  newFields: Partial<MarketingTemplatePreset>,
  existingState: TemplateBuilderState
) => {
  const payload: MarketingTemplatePreset = {
    DeletedAtUtc: newFields.DeletedAtUtc ?? existingState.deletedAtUtc,
    HtmlBody: newFields.HtmlBody ?? existingState.htmlBody,
    HtmlBodyS3FileName: newFields.HtmlBodyS3FileName ?? existingState.htmlBodyS3FileName,
    IsDeleted: newFields.IsDeleted ?? existingState.isDeleted,
    JsonBody: newFields.JsonBody ?? existingState.jsonBody,
    JsonBodyS3FileName: newFields.JsonBodyS3FileName ?? existingState.jsonBodyS3FileName,
    LspId: newFields.LspId ?? existingState.lspId,
    MarketingTemplatePresetId: newFields.MarketingTemplatePresetId ?? existingState.marketingTemplatePresetId,
    TemplateName: newFields.TemplateName ?? existingState.templateName,
    LastModifiedDateUtc: newFields.LastModifiedDateUtc ?? existingState.lastModifiedDateUtc,
  };

  return payload;
};
